// @ts-strict-ignore
import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import { cmsPath } from "./urls";
import CmsPage from "./views/CmsPage";

export const CmsSection: React.FC<RouteComponentProps<any>> = () => (
  <>
    <WindowTitle title="Content Management System" />
    <Switch>
      <Route exact path={cmsPath} component={CmsPage} />
    </Switch>
  </>
);

export default CmsSection;
